import { render, staticRenderFns } from "./createCommissionAssign.vue?vue&type=template&id=4ac0a1fe"
import script from "./createCommissionAssign.vue?vue&type=script&lang=js"
export * from "./createCommissionAssign.vue?vue&type=script&lang=js"
import style0 from "./createCommissionAssign.vue?vue&type=style&index=0&id=4ac0a1fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports